"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSByodComponent = void 0;
const generic_content_service_1 = require("../services/generic.content.service");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const ng_bootstrap_2 = require("@ng-bootstrap/ng-bootstrap");
class CSByodComponent {
    constructor(modalService, genericContentService) {
        this.modalService = modalService;
        this.genericContentService = genericContentService;
    }
    ngOnInit() {
        this.updateTooltip();
        this.showToolTipContent();
    }
    open(content) {
        this.modalService.open(content, { windowClass: 'dark-modal' });
    }
    onBlurHide() {
        this.tooltip.close();
    }
    showToolTipContent() {
        this.loading = true;
        this.genericContentService.getGenericContent('genericContentBYOD').subscribe((data) => {
            this.message = data;
            this.loading = false;
        }, (err) => {
            this.error = err;
            this.loading = false;
        });
    }
    checkLength() {
        let element = document.querySelector('#phoneIdForUpdate');
        const fieldLength = element.value.length;
        if (fieldLength <= 19) {
            return true;
        }
        else {
            element = document.querySelector('#phoneIdForUpdate');
            let fieldValue = element.value;
            fieldValue = fieldValue.substring(0, fieldValue.length - 1);
            element.value = fieldValue;
        }
    }
    updateTooltip() {
        setTimeout(() => {
            const button = document.getElementsByClassName('byod-ques');
            const btnOffsetLeft = button != null && button.length > 0 ? button[0].getBoundingClientRect().left : 0;
            if (window.innerHeight > window.innerWidth) {
                if (btnOffsetLeft <= 95) {
                    this.placementionDirection = 'right-top';
                }
                else if (btnOffsetLeft >= (window.innerWidth - 95)) {
                    this.placementionDirection = 'left-top';
                }
                else {
                    this.placementionDirection = 'top-auto';
                }
                if ((btnOffsetLeft + 215) < (window.innerWidth - 10)) {
                    this.placementionDirection = 'top-auto';
                }
                else {
                    // optional - for galaxy fold
                    if (this.placementionDirection.indexOf('right') > -1 && window.innerWidth < 300) {
                        this.placementionDirection = 'top-auto';
                    }
                }
            }
            else {
                if (window.navigator.userAgent != null && (window.navigator.userAgent.toLowerCase().indexOf('window') > -1
                    || window.navigator.userAgent.toLowerCase().indexOf('mac') > -1)) {
                    // Desktop
                    this.placementionDirection = 'top-right';
                    // need to check offsetLeft for prota mode. when icon near very right then use left-top
                    // when near left use right-top . if the 2 condi not staisfy use top-right
                }
                else {
                    // Mobile - icon near left - need to handle when icon near right side - left top
                    // this.placementionDirection = 'right-top';
                    console.log(button != null && button.length > 0 ? button[0].getBoundingClientRect().left : '');
                    console.log((window.outerWidth > window.innerWidth ? 'scroll exist' : 'no scroll'));
                    if (btnOffsetLeft > (window.innerWidth - 210)) {
                        this.placementionDirection = 'left-top';
                    }
                    else {
                        this.placementionDirection = 'right-top';
                    }
                    if ((this.placementionDirection && this.placementionDirection.indexOf('right') > -1) &&
                        ((btnOffsetLeft + 215) > (window.innerWidth - 10))) {
                        this.placementionDirection = 'left-top';
                    }
                }
            }
        }, 350);
    }
}
exports.CSByodComponent = CSByodComponent;
//# sourceMappingURL=byod.component.js.map